namespace $ { $mol_style_attach( "mol/stack/demo/demo.view.css",
 "[mol_stack_demo_front] {\n\tmargin: auto;\n}\n"
) }